<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <invoices-page />
    </div>
  </div>
</template>

<script>
import InvoicesPage from '../Components/InvoicesPage.vue';
export default {
  name: 'Invoices',
  components: {
    'invoices-page': InvoicesPage,
  },
};
</script>
